import en from './en'
import jp from './jp'
import fr from './fr'
import de from './de'
import it from './it/index'
import es from './es'
import pl from './pl'
import tw from './tw'

export default {
    en,
    jp,
    fr,
    de,
    es,
    it,
    pl,
    tw
}